<template>
    <Teleport to="body">
        <Transition name="snack">
            <div
                v-if="props.modelValue"
                class="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 px-4 py-3 rounded shadow-xl text-white"
                :class="props.variant === 'error' ? 'bg-danger' : 'bg-success'"
            >
                <slot />
            </div>
        </Transition>
    </Teleport>
</template>

<script setup lang="ts">
    import { watch } from 'vue'

    const props = defineProps<{
        modelValue: boolean
        variant?: 'success' | 'error'
        timeout?: number
    }>()

    const emit = defineEmits<{
        'update:modelValue': [value: boolean]
    }>()

    watch(
        () => props.modelValue,
        val => {
            if (val) {
                const t = props.timeout ?? 4000
                window.setTimeout(() => emit('update:modelValue', false), t)
            }
        }
    )
</script>

<style scoped>
    .snack-enter-from,
    .snack-leave-to {
        opacity: 0;
        transform: translate(-50%, 16px);
    }
    .snack-enter-active,
    .snack-leave-active {
        transition: all 200ms ease;
    }
</style>
